import React, { Component } from 'react'
import { makeDefaultFailedContainer } from 'components/container'
import Input from 'shared-web/src/components/Input'
import Toggle from 'components/Toggle'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, HUBSPOT_CLIENT_ID } from 'constants/ResourcesConstants'

const FIND_HUB_ID_LINK = "http://knowledge.hubspot.com/articles/kcs_article/account/where-can-i-find-my-hub-id"

const HUBSPOT_PAYLOAD = {
  client_id: HUBSPOT_CLIENT_ID,
  redirect_uri: `${ APP_URL }/accept-integration/hubspot`
}

const RAW_PARAM_PAYLOAD = '&scope=contacts%20timeline%20forms%20content'

export class HubSpotInstaller extends Component {
  componentWillReceiveProps({ integrationStates, hubspotInjectionState, orgProps }) {
    const currentIntegrationStates = this.props.integrationStates
    const currentInjectionState = this.props.hubspotInjectionState
    const orgActivated = this.props.orgProps.orgActivated

    if (currentIntegrationStates['hubspot'] !== integrationStates['hubspot']) {
      this.setState({ updating: false })
    }

    if (currentInjectionState !== hubspotInjectionState) {
      this.app.actions.NotificationActions.pushNotification({ content: 'Your settings were successfully updated.' })
      if (hubspotInjectionState) {
        const { orgActivated } = this.props.orgProps
        if (!orgActivated) {
          this.app.queries.OrgPropertiesQueries.updateProperties(this.props.org.id, { orgActivated: true })
        }
      }
    }
    if (orgActivated !== orgProps.orgActivated && orgProps.orgActivated) {
      this.app.actions.NotificationActions.pushNotification({
        content: 'Drift is successfully set up and ready to go!',
      })
    }
  }

  handleInjectionStateChange = (event) => {
    this.app.queries.IntegrationsQueries.updateHubspotInjectionState(event.target.checked)
    this.app.queries.IntegrationsQueries.fetchIntegrationStates()
  }

  renderEmbedToggle = () => {
    const { hubspotInjectionState } = this.props
    return (
      <div className="flex-space-between" style={{ paddingBottom: '1rem' }}>
        <Toggle
          defaultChecked={ hubspotInjectionState }
          id="hubspot-injection-state"
          onChange={ this.handleInjectionStateChange.bind(this) }
        />
        <span style={{ display: 'inline-block', paddingLeft: '1rem' }}>Add the Drift widget to my HubSpot hosted pages (COS, Landing Pages & Blog)</span>
      </div>
    )
  }

  render() {
    const { isConnected } = this.props
    const authLink = "https://app.hubspot.com/oauth/authorize"
    return (
      <div>
        <p>Using HubSpot? Let’s make this easy. Clicking connect below will automatically display the Drift chat on your website that you manage with HubSpot.</p>
        { isConnected ? this.renderEmbedToggle() : null }
        <IntegrationConnector
          integrationId="hubspot"
          isOauth={true}
          oauthLink={authLink}
          oauthQueryParams={HUBSPOT_PAYLOAD}
          oauthRawParams={RAW_PARAM_PAYLOAD}
          />
      </div>
    )
  }
}

const HubSpotInstallerContainer = makeDefaultFailedContainer(HubSpotInstaller, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates()
    },
    hubspotInjectionState() {
      return this.app.stores.IntegrationsStore.fetchHubspotInjectionState()
    },
    orgProps() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg()
    },
    org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },
  }
})

export default HubSpotInstallerContainer



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/HubSpotInstaller.js